import {IExportDataSetItem} from "@containers/export/containers/buildData/hooks/types/exportParams";
import {buildHeadColumns, buildHeaderColumnsPdf} from "@containers/export/containers/pdf/helpers/buildHeadColumns";
import {buildBodyContent} from "@containers/export/containers/pdf/helpers/buildBodyContent";

interface IContentItem {
    text: unknown,
    style?: string,
    fillColor?: string,
    margin?: number[],
    bold?: boolean,
}

export const buildBody = <T>(dataSet: IExportDataSetItem<T>): IContentItem[][] => {
    const currentColumns = dataSet.columns.filter((column) => !column.hideExport)
    const baseBody = buildBodyContent({
        data: dataSet.data,
        columns: currentColumns
    })
    if (dataSet?.headColumns?.length) {

        const headColumns = buildHeadColumns<T>(dataSet.headColumns)
        return [
            ...headColumns,
            ...baseBody,
        ]
    }

    const headersColumns = buildHeaderColumnsPdf(currentColumns)

    return [
        headersColumns,
        ...baseBody,
    ]
}